import { Collapse, Switch } from 'antd';
import React from 'react';

import StopPropagationClick from 'ui/utils/StopPropagationClick';

import { Arrow, CollapseWrapper, Wrapper } from './UI';

/**
 * @typedef {Object} PreferenceProps
 * @property {import('react').ReactNode} title
 * @property {import('react').ReactNode} description
 * @property {boolean} checked
 * @property {function} onChange
 * @property {boolean} disabled
 * @property {string} [data-cy]
 */

/** @type {React.FC<PreferenceProps>} */
const Preference = ({ title, description, checked, onChange, disabled, 'data-cy': dataCy }) => (
  <CollapseWrapper defaultActiveKey="panel" ghost expandIcon={Arrow}>
    <Collapse.Panel
      key="panel"
      header={title}
      extra={
        <StopPropagationClick>
          <Switch checked={checked} onChange={onChange} disabled={disabled} data-cy={dataCy} />
        </StopPropagationClick>
      }
    >
      <Wrapper>
        {description}
      </Wrapper>
    </Collapse.Panel>
  </CollapseWrapper>
);

export default Preference;
